module.exports = __webpack_public_path__ + "static/img/158.01f9439.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/158.jpg
// module id = Vk4k
// module chunks = 0